export default __webpack_public_path__ + "static/media/logo-branco-01.48b7e38e.png";